import { useEffect } from "react";
import { useSelector } from "react-redux";

import { applicationStateSelectors } from "store/slices/applicationState/selectors";
import { environmentSelectors } from "store/slices/environment/selector";
import { TrackingService } from "services/Tracking";

// Estendi l'interfaccia Window per includere dataLayer
declare global {
  interface Window {
    dataLayer: unknown[];
  }
}

export const DATADOG_CONFIG = {
  applicationId: "09503fb3-3205-484a-8008-1c77fb245c17",
  clientToken: "pub2cd411cf2672a13a80489e51df4b7f7c",
  site: "datadoghq.eu",
  service: "roomselector",
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  defaultPrivacyLevel: "mask-user-input" as const,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
} as const;

const Tracking = () => {
  const projectInfo = useSelector(applicationStateSelectors.selectProjectInfo);
  const environment = useSelector(environmentSelectors.environment);

  useEffect(() => {
    if (!projectInfo?.code || !environment) {
      return;
    }

    TrackingService.getInstance().initializeTracking(environment);

    if (!projectInfo.GTMCode) return;

    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    const existingGtmScript = document.querySelector(
      `script[src*="googletagmanager.com/gtm.js?id=${projectInfo.GTMCode}"]`,
    );

    if (!existingGtmScript) {
      const script = document.createElement("script");
      script.innerHTML = `
          (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
            var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s),
              dl = l != "dataLayer" ? "&l=" + l : "";
            j.async = true;
            j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
            f.parentNode.insertBefore(j, f);
          })(window, document, "script", "dataLayer", "${projectInfo.GTMCode}");
        `;
      script.async = true;
      document.head.appendChild(script);

      const noscript = document.createElement("noscript");
      const iframe = document.createElement("iframe");
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${projectInfo.GTMCode}`;
      iframe.height = "0";
      iframe.width = "0";
      iframe.style.display = "none";
      iframe.style.visibility = "hidden";
      noscript.appendChild(iframe);
      document.body.appendChild(noscript);
    }
  }, [projectInfo?.code, environment]);

  return null;
};

export default Tracking;
